var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',{attrs:{"query":_vm.GET_PRODUCT_GROUP,"variables":{ id: _vm.id },"fetch-policy":"no-cache","update":function (data) {
    return {
      productGroup: Object.assign({}, data.productGroup,
        {parentGroupId: data.productGroup.parentGroup ? data.productGroup.parentGroup.id : null}),
    };
  }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var data = ref.result.data;
  var isLoading = ref.isLoading;
return [(isLoading)?_c('s-loader'):(data && data.productGroup)?_c('div',[_c('ProductGroupForm',{attrs:{"data":data.productGroup,"query":_vm.UPDATE_PRODUCT_GROUP,"fetch-policy":"no-cache","format-data-for-mutation":_vm.formatForMutation},on:{"mutation-done":_vm.productGroupUpdated}})],1):_c('something-went-wrong')]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }